<!--
    描述：交易完成
    日期：2022/7/26
    创建人：李家宝
-->
<template>
  <div>
    <el-empty
      description="暂无数据"
      v-if="transactionComplete === null"
    ></el-empty>
    <el-descriptions v-else title="交易已完成" :column="5">
      <el-descriptions-item label="操作角色">{{
        transactionComplete.roleName
      }}</el-descriptions-item>
      <el-descriptions-item label="操作企业">{{
        transactionComplete.companyName
      }}</el-descriptions-item>
      <el-descriptions-item label="操作人">{{
        transactionComplete.operatorName
      }}</el-descriptions-item>
      <el-descriptions-item label="操作时间">{{
        transactionComplete.operateDate
      }}</el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
import { confirmTransactionCompletion } from "api/modules/projectManagement";
import { mapState } from "vuex";

export default {
  name: "trade-finish",
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    audit: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapState("user", ["userInfo"])
  },
  data() {
    return {
      transactionComplete: null
    };
  },
  methods: {
    getConfirmTransactionCompletion() {
      confirmTransactionCompletion({
        id: this.rowData.id,
        currentUserId: this.userInfo.id
      }).then(res => {
        if (res.code == 0) {
          this.transactionComplete = res.data;
        }
      });
    }
  },

  created() {
    this.getConfirmTransactionCompletion();
  },

  mounted() {}
};
</script>

<style scoped></style>
